import Layout from '@/views/layout/Layout'

const cmsUniversityInfoRoutes = {
  path: '/cms/scoreline',
  component: Layout,
  redirect: '/cms/scoreline/academy/list',
  name: 'cms.scoreline',
  meta: { title: '历年分数', icon: 'cms' },
  children: [
    {
      path: 'academy/list',
      name: 'cms.scoreline.academy.list',
      component: () => import('@/views/cms/academy/scoreline/list'),
      meta: { title: '院校线', icon: 'ums-admin' }
    },
    {
      path: 'major/list',
      name: 'cms.scoreline.major.list',
      component: () => import('@/views/cms/major/scoreline/list'),
      meta: { title: '专业线', icon: 'ums-admin' }
    }
  ]
}

export default cmsUniversityInfoRoutes



// WEBPACK FOOTER //
// ./src/router/module/cmsScoreline.js